/**
 * Currency Formatting Utilities
 * Provides locale-aware currency formatting using Intl.NumberFormat
 */

/**
 * Format a price with proper currency symbol and locale formatting
 * @param amount - The price amount
 * @param currency - ISO 4217 currency code (e.g., 'USD', 'EUR', 'GBP')
 * @param locale - Optional locale (defaults to user's browser locale)
 * @returns Formatted currency string (e.g., "$4.99", "€4,99", "£4.99")
 */
export function formatCurrency(
  amount: number,
  currency: string = 'USD',
  locale?: string
): string {
  try {
    const userLocale = locale || navigator.language || 'en-US';
    
    const formatter = new Intl.NumberFormat(userLocale, {
      style: 'currency',
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    
    return formatter.format(amount);
  } catch (error) {
    // Fallback if currency code is invalid or not supported
    console.warn(`Failed to format currency: ${currency}`, error);
    return `${currency.toUpperCase()} ${amount.toFixed(2)}`;
  }
}
